import { YTime, $time } from './time';

export namespace $fn {
    export function TRUE() {
        return true;
    }

    export function FALSE() {
        return false;
    }

    export function UNDEFINED() {
        return undefined;
    }

    export function ID<T>(v: T) {
        return v;
    }

    export function NOOP() {
    }

    export function ICOMPARE(a: string, b: string) {
        return a.toLocaleLowerCase().localeCompare(b.toLocaleLowerCase());
    }

    export function UNIQUE_FILTER<T>(v: T, i: number, a: T[]) {
        for(let j = 0; j < i; j++) {
            if(a[j] == v) return false;
        }
        return true;
    }

    export function REDUCE_TO_EQUAL<T>(p: T | undefined, c: T, n: number) {
        return (n == 0 || p == c) ? c : undefined;
    }

    export function reduceToEqual<T>(equal?: (a: T, b: T) => boolean) {
        return equal ? ((p: T | undefined, c: T, n: number) => (n == 0 || (p != undefined && equal(p, c))) ? c : undefined) : REDUCE_TO_EQUAL;
    }

    export function throttled<A extends any[]>(fn: (...args: A) => void, interval: number) {
        let wait_till: YTime | undefined;
        let timeout: number | undefined;
        let stored_args: A | undefined;
        return (...args: A) => {
            const now = $time.now();
            if(wait_till && now.before(wait_till)) {
                stored_args = args;
                if(timeout == undefined) {
                    timeout = setTimeout(() => {
                        fn(...stored_args!);
                        stored_args = undefined;
                        timeout = undefined;
                        wait_till = $time.now().add(interval, $time.second);
                    }, wait_till.sub(now, $time.millisecond));
                }
            } else {
                if(timeout != undefined) {
                    clearTimeout(timeout);
                    stored_args = undefined;
                    timeout = undefined;
                }
                fn(...args);
                wait_till = now.add(interval, $time.second);
            }
        }
    }

    export function debounce<A extends any[]>(fn: (...args: A) => void, interval: number) {
        let timeout: number | undefined;
        return (...args: A) => {
            if(timeout != undefined) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(() => {
                fn(...args);
                timeout = undefined;
            }, interval * 1000);
        }
    }

    export function deduplicate<A extends any[]>(fn: (...args: A) => void) {
        let timeout: number | undefined;
        let stored_args: A | undefined;
        return (...args: A) => {
            stored_args = args;
            if(timeout == undefined) {
                timeout = setTimeout(() => {
                    fn(...stored_args!);
                    stored_args = undefined;
                    timeout = undefined;
                }, 0);
            }
        }
    }

    export function lazy<T>(fn: () => T) {
        let value: T | undefined;

        return () => {
            if(value === undefined)
                value = fn();
            return value;
        };
    }

    export function lazy1<T>(fn: (key: string & any) => T) {
        const values: { [key: string]: T } = {};

        return (key: string) => {
            if(!(key in values))
                values[key] = fn(key);
            return values[key];
        };
    }
}
